import { useTranslation } from "react-i18next";
import { pricingCards } from "../../../mocks/process";

export default function PricingSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-cream">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-8 md:mb-10">
          <span className="tag-label mb-3 inline-block">{t("process.pricing.label")}</span>
          <h2 className="mb-3">{t("process.pricing.title")}</h2>
          <p className="text-medium-gray max-w-3xl mx-auto">
            {t("process.pricing.desc")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-8 md:mt-10">
          {pricingCards.map((card, index) => (
            <div
              key={card.id}
              className="group relative bg-white rounded-xl p-6 md:p-7 border border-warm-gray/30 hover:border-champagne/40 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Step number badge with hover color shift */}
              <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-champagne flex items-center justify-center shadow-sm transition-all duration-300 group-hover:scale-110 group-hover:bg-graphite">
                <span className="text-graphite font-bold text-base transition-colors duration-300 group-hover:text-champagne">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>

              <div className="w-10 h-10 rounded-lg bg-champagne/10 flex items-center justify-center mb-4 transition-all duration-300 group-hover:scale-110 group-hover:bg-champagne/20">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-champagne text-lg transition-transform duration-300 group-hover:scale-110" />
                </span>
              </div>

              <h3 className="font-semibold text-graphite text-base mb-2">
                {t(card.titleKey)}
              </h3>
              <p className="text-medium-gray text-base leading-relaxed">
                {t(card.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}